
import { defineComponent, ref, computed } from '@nuxtjs/composition-api'
import { domainByCountry, leaveShopOnCurrentDomain } from '~/assets/ts/Domains'

type shopStructure = {
  shopId: number
  name: {
    main: string
    list: string
    international: string
  }
  address: {
    postalCode: string
    streetAddress: string
    addressLocality: string
    addressCountry: string
  }
  town: string
  slug: string
  geo: any
}

export default defineComponent({
  props: ['shops', 'country'],
  setup(props) {
    /**
     * Search
     */

    const searchTerm = ref('' as string)

    const filteredShops = computed(() => {
      const filteredList: {
        [key: string]: shopStructure[]
      } = {
        country: [],
      }

      if (searchTerm.value === '') {
        for (const idx in props.shops) {
          if (
            typeof props.shops[idx].address === 'undefined' ||
            typeof props.shops[idx].address.addressCountry === 'undefined'
          ) {
            console.log('addressCountry missing', props.shops[idx])
          } else {
            const storeCountry =
              props.shops[idx].address.addressCountry.toLowerCase()

            if (typeof filteredList[storeCountry] === 'undefined') {
              filteredList[storeCountry] = []
            }

            filteredList[storeCountry].push(props.shops[idx])

            if (storeCountry === 'kr') {
              filteredList[storeCountry].sort((a, b) =>
                a.name.list > b.name.list ? 1 : -1
              )
            } else {
              filteredList[storeCountry].sort((a, b) =>
                a.address.addressLocality > b.address.addressLocality ? 1 : -1
              )
            }
          }
        }
      } else {
        const term = searchTerm.value.toLowerCase()

        for (const idx in props.shops) {
          if (
            typeof props.shops[idx].address === 'undefined' ||
            typeof props.shops[idx].address.addressCountry === 'undefined'
          ) {
            console.log('addressCountry missing', props.shops[idx])
          } else {
            const storeCountry =
              props.shops[idx].address.addressCountry.toLowerCase()

            if (typeof filteredList[storeCountry] === 'undefined') {
              filteredList[storeCountry] = []
            }

            if (
              props.shops[idx].name.main.toLowerCase().includes(term) ||
              props.shops[idx].name.list.toLowerCase().includes(term) ||
              props.shops[idx].name.international
                .toLowerCase()
                .includes(term) ||
              props.shops[idx].address.addressLocality
                .toLowerCase()
                .includes(term) ||
              props.shops[idx].address.postalCode
                .toLowerCase()
                .includes(term) ||
              props.shops[idx].address.streetAddress
                .toLowerCase()
                .includes(term) ||
              props.shops[idx].address.addressCountry
                .toLowerCase()
                .includes(term)
            ) {
              filteredList[storeCountry].push(props.shops[idx])

              filteredList[storeCountry].sort((a, b) =>
                a.address.addressLocality > b.address.addressLocality ? 1 : -1
              )
            }
          }
        }
      }

      return filteredList
    })

    return {
      filteredShops,
      domainByCountry,
      leaveShopOnCurrentDomain,
    }
  },
})
